import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCursor3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconCursor3"><Path d="M4.89354 2.93772C3.66299 2.4351 2.4351 3.663 2.93772 4.89354L8.71849 19.0465C9.12391 20.039 10.4096 20.2981 11.1678 19.5399L12.7503 17.9574L16.1896 21.3967C16.7754 21.9825 17.7252 21.9825 18.311 21.3967L21.3967 18.311C21.9825 17.7252 21.9825 16.7754 21.3967 16.1896L17.9574 12.7503L19.5399 11.1678C20.2981 10.4096 20.039 9.12391 19.0465 8.71849L4.89354 2.93772Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCursor3;
